import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  mainURL = 'auth/';
  baseURL = environment.baseURL;
  constructor(private http: HttpClient) { }

  loginWithGoogle(user: any) {
    return this.http.post(this.baseURL + this.mainURL + 'loginWithGoogle', user);
  }

  loginWithLinkedIn(authCode: any) {
    return this.http.post(this.baseURL + this.mainURL + 'loginWithLinkedIn', authCode);
  }

  loginAsGuest() {
    return this.http.post(this.baseURL + this.mainURL + 'loginAsGuest', {});
  }

  loginAsUser(user: any) {
    return this.http.post(this.baseURL + this.mainURL + 'loginAsUser', user);
  }

  registerUser(user: any) {
    return this.http.post(this.baseURL + this.mainURL + 'createUser', user);
  }

  refreshAccessToken(user: any) {
    return this.http.post(this.baseURL + this.mainURL + 'refresh-token', user);
  }
}
